// API Url Constants

export default {
    USER_MANAGEMENT_AUTH_SIGN_IN: "v1/user-management/auth/sign-in",
    USER_MANAGEMENT_AUTH_OTP_CODE: "v1/user-management/auth/otp-code",
    USER_MANAGEMENT_AUTH_SIGN_UP: "v1/user-management/auth/sign-up",
    USER_MANAGEMENT_AUTH_SIGN_OUT: "v1/user-management/auth/sign-out",
    USER_MANAGEMENT_AUTH_SIGN_IN_GOOGLE: "v1/user-management/auth/sign-in-google",
    USER_MANAGEMENT_AUTH_CALLBACK_GOOGLE: "v1/user-management/auth/callback-google",
    USER_MANAGEMENT_AUTH_REQUEST_RESET_PASSWORD: "v1/user-management/auth/request-reset-password",
    USER_MANAGEMENT_AUTH_RESET_PASSWORD: "v1/user-management/auth/reset-password",
    USER_MANAGEMENT_AUTH_CAPTCHA: "v1/user-management/auth/captcha",

    USER_MANAGEMENT_JWT_TOKEN_ALL: "v1/user-management/jwt-token/all",
    USER_MANAGEMENT_JWT_TOKEN_PAGINATE: "v1/user-management/jwt-token/paginate",
    USER_MANAGEMENT_JWT_TOKEN_ID: "v1/user-management/jwt-token/",
    USER_MANAGEMENT_JWT_TOKEN_CREATE: "v1/user-management/jwt-token",
    USER_MANAGEMENT_JWT_TOKEN_REMOVE: "v1/user-management/jwt-token/",

    USER_MANAGEMENT_NESHAN_GEOCODING: "v1/user-management/neshan/geocoding",
    USER_MANAGEMENT_NESHAN_ADDRESS: "v1/user-management/neshan/address",
    USER_MANAGEMENT_NESHAN_DIRECTION: "v1/user-management/neshan/direction",

    USER_MANAGEMENT_PERMISSION_ALL: "v1/user-management/permission/all",
    USER_MANAGEMENT_PERMISSION_PAGINATE: "v1/user-management/permission/paginate",
    USER_MANAGEMENT_PERMISSION_ID: "v1/user-management/permission/",
    USER_MANAGEMENT_PERMISSION_CREATE: "v1/user-management/permission",
    USER_MANAGEMENT_PERMISSION_UPDATE: "v1/user-management/permission/",
    USER_MANAGEMENT_PERMISSION_REMOVE: "v1/user-management/permission/",

    USER_MANAGEMENT_PROFILE_MY_ACCOUNT: "v1/user-management/profile",
    USER_MANAGEMENT_PROFILE_UPDATE_AVATAR: "v1/user-management/profile/avatar",
    USER_MANAGEMENT_PROFILE_UPDATE_USERNAME: "v1/user-management/profile/username",
    USER_MANAGEMENT_PROFILE_UPDATE: "v1/user-management/profile",

    USER_MANAGEMENT_ROLE_ALL: "v1/user-management/role/all",
    USER_MANAGEMENT_ROLE_PAGINATE: "v1/user-management/role/paginate",
    USER_MANAGEMENT_ROLE_ID: "v1/user-management/role/",
    USER_MANAGEMENT_ROLE_CREATE: "v1/user-management/role",
    USER_MANAGEMENT_ROLE_UPDATE: "v1/user-management/role/",
    USER_MANAGEMENT_ROLE_REMOVE: "v1/user-management/role/",
    USER_MANAGEMENT_ROLE_PERMISSION_ALL: "v1/user-management/role/permission/all/",
    USER_MANAGEMENT_ROLE_PERMISSION_PAGINATE: "v1/user-management/role/permission/paginate/",
    USER_MANAGEMENT_ROLE_PERMISSION_UPDATE: "v1/user-management/role/permission/",
    USER_MANAGEMENT_ROLE_PERMISSION_REMOVE: "v1/user-management/role/permission/",

    USER_MANAGEMENT_USER_ALL: "v1/user-management/user/all",
    USER_MANAGEMENT_USER_PAGINATE: "v1/user-management/user/paginate",
    USER_MANAGEMENT_USER_ID: "v1/user-management/user/",
    USER_MANAGEMENT_USER_USERNAME: "v1/user-management/user/username/",
    USER_MANAGEMENT_USER_CREATE: "v1/user-management/user",
    USER_MANAGEMENT_USER_CREATE_MULTI: "v1/user-management/user/multi",
    USER_MANAGEMENT_USER_UPDATE: "v1/user-management/user/",
    USER_MANAGEMENT_USER_REMOVE: "v1/user-management/user/",
    USER_MANAGEMENT_USER_ROLE_ALL: "v1/user-management/user/role/all/",
    USER_MANAGEMENT_USER_ROLE_UPDATE: "v1/user-management/user/role/",

    TICKET_MANAGEMENT_TICKET_ALL: "v1/ticket-management/ticket/all",
    TICKET_MANAGEMENT_TICKET_PAGINATE: "v1/ticket-management/ticket/paginate",
    TICKET_MANAGEMENT_TICKET_DAY: "v1/ticket-management/ticket/day/",
    TICKET_MANAGEMENT_TICKET_EXCEL: "v1/ticket-management/ticket/excel",
    TICKET_MANAGEMENT_TICKET_ID: "v1/ticket-management/ticket/",
    TICKET_MANAGEMENT_TICKET_CREATE: "v1/ticket-management/ticket",
    TICKET_MANAGEMENT_TICKET_PUBLISH: "v1/ticket-management/ticket/publish/",
    TICKET_MANAGEMENT_TICKET_UPDATE: "v1/ticket-management/ticket/",
    TICKET_MANAGEMENT_TICKET_REMOVE: "v1/ticket-management/ticket/",

    TICKET_MANAGEMENT_PRICE_ALL: "v1/ticket-management/price/all",
    TICKET_MANAGEMENT_PRICE_PAGINATE: "v1/ticket-management/price/paginate",
    TICKET_MANAGEMENT_PRICE_DESTINATION: "v1/ticket-management/price/destination/",
    TICKET_MANAGEMENT_PRICE_ID: "v1/ticket-management/price/",
    TICKET_MANAGEMENT_PRICE_CREATE: "v1/ticket-management/price",
    TICKET_MANAGEMENT_PRICE_UPDATE: "v1/ticket-management/price/",
    TICKET_MANAGEMENT_PRICE_REMOVE: "v1/ticket-management/price/",

    TICKET_MANAGEMENT_COMPANY_ALL: "v1/ticket-management/company/all",
    TICKET_MANAGEMENT_COMPANY_PAGINATE: "v1/ticket-management/company/paginate",
    TICKET_MANAGEMENT_COMPANY_ID: "v1/ticket-management/company/",
    TICKET_MANAGEMENT_COMPANY_CREATE: "v1/ticket-management/company",
    TICKET_MANAGEMENT_COMPANY_PUBLISH: "v1/ticket-management/company/publish/",
    TICKET_MANAGEMENT_COMPANY_UPDATE: "v1/ticket-management/company/",
    TICKET_MANAGEMENT_COMPANY_REMOVE: "v1/ticket-management/company/",

    TICKET_MANAGEMENT_PRIORITY_ALL: "v1/ticket-management/priority/all",
    TICKET_MANAGEMENT_PRIORITY_PAGINATE: "v1/ticket-management/priority/paginate",
    TICKET_MANAGEMENT_PRIORITY_ID: "v1/ticket-management/priority/",
    TICKET_MANAGEMENT_PRIORITY_CREATE: "v1/ticket-management/priority",
    TICKET_MANAGEMENT_PRIORITY_UPDATE: "v1/ticket-management/priority/",
    TICKET_MANAGEMENT_PRIORITY_REMOVE: "v1/ticket-management/priority/",

    HOST_MANAGEMENT_HOST_ALL: "v1/host-management/host/all",
    HOST_MANAGEMENT_HOST_PAGINATE: "v1/host-management/host/paginate",
    HOST_MANAGEMENT_HOST_ID: "v1/host-management/host/",
    HOST_MANAGEMENT_HOST_CREATE: "v1/host-management/host",
    HOST_MANAGEMENT_HOST_PUBLISH: "v1/host-management/host/publish/",
    HOST_MANAGEMENT_HOST_UPDATE: "v1/host-management/host/",
    HOST_MANAGEMENT_HOST_UPLOAD_FILE: "v1/host-management/host/upload/",
    HOST_MANAGEMENT_HOST_REMOVE_UPLOAD_FILE: "v1/host-management/host/file/",
    HOST_MANAGEMENT_HOST_REMOVE: "v1/host-management/host/",

    HOST_MANAGEMENT_DATA_META: "v1/host-management/data/meta",

    FILE_MANAGEMENT_FILE_PAGINATE: "v1/file-management/file/paginate",
    FILE_MANAGEMENT_FILE_UPLOAD: "v1/file-management/file/upload",
    FILE_MANAGEMENT_FILE_REMOVE: "v1/file-management/file/",
    FILE_MANAGEMENT_FILE_DOWNLOAD: "v1/file-management/file/download/",

    FILE_MANAGEMENT_DIRECTORY_ALL: "v1/file-management/directory/all",
    FILE_MANAGEMENT_DIRECTORY_ID: "v1/file-management/directory/",
    FILE_MANAGEMENT_DIRECTORY_CREATE: "v1/file-management/directory",
    FILE_MANAGEMENT_DIRECTORY_UPDATE: "v1/file-management/directory/",
    FILE_MANAGEMENT_DIRECTORY_REMOVE: "v1/file-management/directory/",

    BASIC_INFORMATION_CITY_ALL: "v1/basic-information/city/all",
    BASIC_INFORMATION_CITY_PAGINATE: "v1/basic-information/city/paginate",
    BASIC_INFORMATION_CITY_ID: "v1/basic-information/city/",
    BASIC_INFORMATION_CITY_CREATE: "v1/basic-information/city",
    BASIC_INFORMATION_CITY_UPDATE: "v1/basic-information/city/",
    BASIC_INFORMATION_CITY_REMOVE: "v1/basic-information/city/",

    BASIC_INFORMATION_PROVINCE_ALL: "v1/basic-information/province/all",
    BASIC_INFORMATION_PROVINCE_PAGINATE: "v1/basic-information/province/paginate",
    BASIC_INFORMATION_PROVINCE_ID: "v1/basic-information/province/",
    BASIC_INFORMATION_PROVINCE_CREATE: "v1/basic-information/province",
    BASIC_INFORMATION_PROVINCE_UPDATE: "v1/basic-information/province/",
    BASIC_INFORMATION_PROVINCE_REMOVE: "v1/basic-information/province/",
    BASIC_INFORMATION_PROVINCE_CITIES: "v1/basic-information/province/cities",
}
